import React from 'react';

export const MaineInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of Maine</p>
        <p className="eds-l-mar-bot-1">
            <strong>Relief Interim SBA Finance Loan Program</strong> |&nbsp;
            <a
                href="https://www.famemaine.com/business/programs/covid-19-relief-loan-programs/covid-19-relief-interim-sba-finance-loan-program/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            The COVID-19 Relief Interim SBA Finance Loan Program provides FAME
            Direct Loans of up to $100,000 with special terms available to
            eligible borrowers who provide proof of commitment for SBA
            financing. Eligible borrowers will provide proof of commitment for
            SBA financing with the intention the FAME loan would be originated
            for use to business owner until such time as SBA loan is funded. The
            SBA loan would then pay-off the FAME loan.
        </p>

        <p className="eds-l-mar-bot-1 eds-l-mar-top-4">
            <strong>Relief Business Direct Loan Program</strong> |&nbsp;
            <a
                href="https://www.famemaine.com/business/programs/covid-19-relief-loan-programs/covid-19-relief-business-direct-loan-program/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            The COVID-19 Relief Business Direct Loan Program provides FAME
            Direct Loans of up to $50,000 with special terms available to
            Maine-based businesses experiencing interruption or hardship due to
            COVID-19. These special terms are available only on applications
            submitted via the FAME Direct Loan Program on or after March 20,
            2020. Eligible borrowers with complete applications will have their
            applications reviewed and approved in an expedited manner.
        </p>
    </div>
);
